const PUBLISH_STATUSES = {
  PUBLISHED: 'published',
  INACTIVE: 'inactive',
  UNDER_REVISION: 'under_revision',
  NEW: 'new',
};

export default PUBLISH_STATUSES;
